/**
 * FATE & GRÂCE — Mock Data
 * Utilisé comme fallback quand le backend est inaccessible (développement / hors-ligne).
 * Toutes les structures correspondent aux serializers Django attendus.
 */

export const MOCK_USERS = [
  
];

export const MOCK_PLATS = [
  
];

export const MOCK_TABLES = [
 
];

export const MOCK_ORDERS = [
  
];

export const MOCK_PRODUCTS = [
  
];

export const MOCK_MOVEMENTS = [
  
];

export const MOCK_INVOICES = [
  
];

export const MOCK_AUDIT = [
  
];

export const ROLES = {
  serveur:       "Serveur",
  cuisinier:     "Cuisinier",
  gérant:        "Gérant",
  gestionnaire:  "Gestionnaire de Stock",
  manager:       "Manager",
  auditeur:      "Auditeur",
  admin:         "Administrateur",
};
